import styled, { css } from 'styled-components';
import { ifNotProp, switchProp } from 'styled-tools';
import { media } from '@prisjakt/ui-base';
import { colors } from '@prisjakt/ui-base/styles/variables';

export enum VARIANTS {
  DEFAULT = 'DEFAULT',
  CAMPAIGN = 'CAMPAIGN',
  HEADING = 'HEADING',
  REVIEWS = 'REVIEWS',
  PRICE_LIST = 'PRICE_LIST',
}

export const campaignImageHeight = 31;

const defaultNoLogoCss = css`
  font-size: 12px;
  line-height: 1.3em;
  word-break: break-word;
  display: flex;
  align-items: center;
`;

const priceListNoLogoCss = css`
  ${defaultNoLogoCss}
  text-align: center;
`;

const campaignNoLogoCss = css`
  font-size: 10px;
  color: ${colors.darkBlue2};
  max-width: 100%;
  height: ${campaignImageHeight}px;
  line-height: ${campaignImageHeight}px;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border: 1px solid ${colors.lightGray1};
  ${media.mediumUp`
    font-size: 12px;
  `};
`;

const reviewsNoLogoCss = css`
  color: ${colors.lightBlue3};
  text-decoration: underline;
`;

type StoreLogoProps = {
  showLogo: boolean;
  variant: 'DEFAULT' | 'CAMPAIGN' | 'HEADING' | 'REVIEWS' | 'PRICE_LIST';
  logoWidth: number;
  showHighResolutionLogo: boolean;
};

export const StoreLogo = styled.div<StoreLogoProps>(
  props => css`
    max-width: ${props.showHighResolutionLogo
      ? props.logoWidth / 2 // Render logos at half size to prevent blurryness on retina screens
      : props.logoWidth}px;

    ${ifNotProp(
      'showLogo',
      switchProp('variant', {
        [VARIANTS.DEFAULT]: defaultNoLogoCss,
        [VARIANTS.HEADING]: defaultNoLogoCss,
        [VARIANTS.PRICE_LIST]: priceListNoLogoCss,
        [VARIANTS.CAMPAIGN]: campaignNoLogoCss,
        [VARIANTS.REVIEWS]: reviewsNoLogoCss,
      })
    )};
  `
);

export const StoreLogoText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;
